"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkbox = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Checkbox = exports.Checkbox = function Checkbox(_ref) {
  var label = _ref.label,
    labelComponent = _ref.labelComponent,
    _ref$labelClassName = _ref.labelClassName,
    labelClassName = _ref$labelClassName === void 0 ? "" : _ref$labelClassName,
    _ref$checked = _ref.checked,
    checked = _ref$checked === void 0 ? false : _ref$checked,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    _ref$boost = _ref.boost,
    boost = _ref$boost === void 0 ? false : _ref$boost;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    _react["default"].createElement("label", {
      className: "checkmarkContainer my-1".concat(labelClassName ? " ".concat(labelClassName) : "")
    }, labelComponent || label, /*#__PURE__*/_react["default"].createElement("input", {
      "data-testid": "Checkbox-testSelector",
      type: "checkbox",
      checked: checked,
      disabled: disabled,
      onChange: onChange
    }), /*#__PURE__*/_react["default"].createElement("span", {
      className: "checkmark".concat(boost ? " checkmark-boost" : "")
    }))
  );
};